module.exports = __webpack_public_path__ + "img/sofortueberweisung-data.af06c88b.svg";